import { WeekDay } from 'src/app/core/services/extended-program-guide.service';

/**
 * Converts a WeekDay enum to a number that can be used with DateTime.weekday
 */
export default function getDateTimeWeekDay(weekDay: WeekDay): number {
  switch (weekDay) {
    case WeekDay.Monday:
      return 1;
    case WeekDay.Tuesday:
      return 2;
    case WeekDay.Wednesday:
      return 3;
    case WeekDay.Thursday:
      return 4;
    case WeekDay.Friday:
      return 5;
    case WeekDay.Saturday:
      return 6;
    case WeekDay.Sunday:
      return 7;
  }
}
